import { yupResolver } from '@hookform/resolvers/yup';

import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';

import Button from 'components/field/Button';
import Form from 'components/form/Form';
import { ModalActions } from 'components/global/styled/Modal.styled';

import useAxiosPrivate from 'hooks/useAxiosPrivate';

import AccountBillingDetails from 'pages/Settings/General/AccountBillingDetails';

import { INVOICE } from 'services/consts';

import { setUserGeneralSettings } from 'stores/userSlice';

import AppLogger from 'utils/AppLogger';
import { ACCOUNT_TYPES } from 'utils/constants';

import useBillingDetailsValidation from '../../hooks/useBillingValidation';
import { ModalContentWrapper } from '../SubscriptonAccountModal.styled';

const BillingInformation = ({ closeModal, prevStep, nextStep }) => {
	const { isBillingValid, billingDetailsSchema, billingDefaults } = useBillingDetailsValidation();
	const axios = useAxiosPrivate();
	const dispatch = useDispatch();
	const formMethods = useForm({
		resolver: yupResolver(isBillingValid ? null : billingDetailsSchema),
		defaultValues: {
			...(isBillingValid ? {} : billingDefaults)
		}
	});
	const {
		handleSubmit,
		formState: { isSubmitting, isLoading: isFormLoading }
	} = formMethods;
	const isLoading = isSubmitting || isFormLoading;
	const updateBillingInfo = async (data) => {
		try {
			const addressData = {
				address: data.address,
				notVATRegistered: data.notVATRegistered,
				companyName: data.companyName,
				invoiceType: data.invoiceType,
				VATNumber: data.invoiceType === ACCOUNT_TYPES.COMPANY ? data.VATNumber : null,
				CRNumber: data.invoiceType === ACCOUNT_TYPES.COMPANY ? data.CRNumber : null,
				fullName: data.invoiceType === ACCOUNT_TYPES.PERSONAL ? data.fullName : null,
				idNumber: data.invoiceType === ACCOUNT_TYPES.PERSONAL ? data.idNumber : null,
				taxOffice: data.invoiceType === ACCOUNT_TYPES.COMPANY ? data.taxOffice : null,
				FLDocStatus: data.invoiceType === ACCOUNT_TYPES.FREELANCER ? 'UNVERIFIED' : '',
				CRDocStatus: data.invoiceType === ACCOUNT_TYPES.COMPANY ? 'UNVERIFIED' : ''
			};
			const response = await axios.post(INVOICE.UPDATE_BILLING_INFO, addressData);
			if (response.status === 200) {
				dispatch(setUserGeneralSettings(addressData));
				nextStep();
			} else {
				AppLogger.error(response);
			}
		} catch (error) {
			AppLogger.error(error);
		}
	};
	return (
		<>
			<ModalContentWrapper>
				<Form formMethods={formMethods}>
					<div>
						<AccountBillingDetails chargeAccount />
					</div>
				</Form>
			</ModalContentWrapper>
			<ModalActions>
				<Button variant="outline" label="cancel" onClick={closeModal} />
				<Button
					variant="outline"
					label="previous"
					onClick={() => {
						prevStep();
					}}
				/>

				<Button
					variant="blue"
					loading={isLoading}
					label="next"
					onClick={handleSubmit(updateBillingInfo, AppLogger.log)}
				/>
			</ModalActions>
		</>
	);
};

export default BillingInformation;
